import { render, staticRenderFns } from "./RecordConcept.vue?vue&type=template&id=1161be00&"
import script from "./RecordConcept.vue?vue&type=script&lang=js&"
export * from "./RecordConcept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports